import React, { useState, useEffect } from "react";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import apiKey from "../../../common/config/apiKey";
import apiCall from "../../../common/config/apiCall";
import { useSearchParams, useLocation } from "react-router-dom";
import useBookingForm from "../../../hooks/useBookingForm";
import calculateTotalPrice from "../../../common/libs/caclulateTotalPrice";
import { FaCheck } from "react-icons/fa";

import validateBookingForm from "../../../common/libs/validateBookingForm";
import UserDetails from "./UserDetails";
import VehicleDetails from "./VehicleDetails";
// import Offer from "./Offer";
// import Confirm from "./Confirm";
import StripePay from "./StripePay";
import Cookies from "js-cookie";
import TravelDetails from "./TravelDetails";
import { inComingIncompleteBooking } from "../../../common/config/socket";
import {
  updateTrackingReferenceFromBooking,
  loadTrackingData
} from "../../../common/libs/tracking";

const BookingForm = ({
  product,
  airports,
  site,
  cancellation,
  setCancellation,
  setSMS,
  vehicles,
  setVehicles,
  sms,
  singleAirport,
}) => {
  const stripePromise = site?.stripe ? loadStripe(site?.stripe?.key) : null;
  const [params] = useSearchParams();
  const location = useLocation();
  const pathname = location.pathname;
  const getReference = params.get("reference_no");
  const getDeparture = params.get("departure");
  const getArrival = params.get("arrival");
  const getPromocode = params.get("promocode");
  const getAirport = params.get("airport");
  const singleProduct = params.get("product");
  const sku = params.get("sku");



  const [state, setState] = useState("initial");
  const [responseError, setResponseError] = useState("");
  const [syncBookingState, setSyncBookingState] = useState("initial");
  const [status, setStatus] = useState("");
  const [reference_no, setReference_no] = useState(
    getReference ? [getReference] : ""
  );
  const [multi_mode_reference_no, setMulti_mode_reference_no] = useState(
    getReference ? `MM-${getReference}` : ""
  );
  const [supplierCost, setSupplierCost] = useState("");
  const [agree, setAgree] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errors, setErrors] = useState([]);
  const [form, setFormField, setForm] = useBookingForm();
  const [cookie, setCookie] = useState(null);
  const [error, setAgreeError] = useState({});

  const [validationErrorState, setValidationErrorState] = useState("initial");

  // Stripe
  const [clientSecret, setClientSecret] = useState("");
  const [stripePaymentIntent, setStripePaymentIntent] = useState("");

  // TRUSTPAYMENT
  const [trustPaymentCode, setTrustPaymentCode] = useState("");
  const [trustPaymentTimeStamp, setTrustPaymentTimeStamp] = useState("");

  // REVOLUTE PAYMENT
  const [revolutepaymentData, setRevolutePaymentData] = useState();

  // TALKSOLUTIONS
  const [talksolutionCode, setTalksolutionCode] = useState("");

  let price = product?.payment
    ? (parseFloat(
      product?.payment?.commission_amount ?? product?.payment?.amount ?? 0
    ) +
      parseFloat(product?.payment?.extra_charges ?? 0) -
      parseFloat(product?.payment?.discount ?? 0)) *
    vehicles.length
    : parseFloat(
      product?.pay_later_status
        ? product?.commission_price ?? 0
        : product?.price ?? 0
    ) * vehicles.length;

  const total = calculateTotalPrice(product, price, cancellation, sms);
  console.log(total, "total");
  // TAKEPAYMENTDATA
  const [takepaymentData, setTakepaymentData] = useState();
  // WORLDPAY
  const [worldpayState, setWorldpayState] = useState("initial");
  const [worldpaySession, setWorldpaySession] = useState("");
  const [worldpayRedirectUrl, setWorldpayRedirectUrl] = useState("");
  // PAYPAL SETTING
  const [isForm, setIsForm] = useState(false);
  const [isVehicle, setIsVehicle] = useState(false);

  let updateAirports = [];

  if (airports?.length) {
    airports?.map((airport) => {
      updateAirports.push({
        value: airport.code,
        label: airport.name,
        terminal: airport.terminal,
      });
    });
  }

  let findIndex = updateAirports.findIndex((a) => a.value === getAirport);

  const intentRef = React.useRef(false);

  const fetchData = async () => {
    let response = await apiCall(
      "post",
      `/stripe/paymentIntent/create`,
      {
        key: apiKey,
        amount: total,
        api_tag: product?.api_tag,
      },
      {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      pathname
    );

    if (response?.data?.client_secret) {
      setClientSecret(response?.data?.client_secret);
      setStripePaymentIntent(response?.data?.payment_intent);
    } else {
      setClientSecret("");
      setStripePaymentIntent("");
    }
  };

  React.useEffect(() => {
    if (intentRef.current) return;
    intentRef.current = true;
    if (site?.stripe) {
      if (!stripePaymentIntent) {
        fetchData();
      }
    }
  }, [site?.stripe, stripePaymentIntent, total]);

  useEffect(() => {
    vehicles?.map((vehicle) => {
      const { make, model, color, reg_no } = vehicle;
      if (make.length && model.length && color.length && reg_no.length) {
        setIsVehicle(true);
      }
    });
    if (
      form.title.length &&
      form.first_name.length &&
      form.last_name.length &&
      form.contact_no.length &&
      form.email.length &&
      syncBookingState === "initial"
    ) {
      setIsForm(true);
      const delayInterval = setTimeout(() => {
        handleSyncBooking();
      }, 3000);
      return () => clearTimeout(delayInterval);
    }
  }, [form, vehicles, syncBookingState]);

  useEffect(() => {
    let quoteAmount = parseFloat(product.price);
    // @ts-ignore
    setSupplierCost(vehicles?.length * quoteAmount);
  }, [vehicles, product.price]);

  // useEffect(() => {
  //   if (typeof window.sessionStorage !== "undefined") {
  //     const getDetails = JSON.parse(sessionStorage.getItem("detail"));
  //     if (getDetails) {
  //       let obj = { ...getDetails };

  //       if (Object.values(obj)?.length > 0) {
  //         setForm(obj);
  //         setVehicles(getDetails?.vehicles);
  //         setSMS(getDetails?.sms_confirmation == 1 ? true : false);
  //         setCancellation(getDetails?.cancellation_status == 1 ? true : false);
  //       }
  //     }
  //   }
  // }, []);

  useEffect(() => {
    let value = Cookies.get("customCid");
    if (value) {
      setCookie(value);
    }
  }, []);



  const handleSyncBooking = async (paymentType = "") => {
    setSyncBookingState("triggered");
    setStatus("");
    setResponseError("");

    //@ts-ignore
    form.vehicles = vehicles;
    let details = {
      key: apiKey,
      api_tag: product.api_tag ? product.api_tag : "",
      option_id: product?.option_id ? JSON.stringify(product?.option_id) : "",
      search_id: product?.search_id ? product?.search_id : "",
      multi_mode_reference_no,
      reference_no,
      status: "0",
      departure: moment(getDeparture).format("DD-MM-yyyy HH:mm"),
      arrival: moment(getArrival).format("DD-MM-yyyy HH:mm"),
      sku: product?.sku,
      amount: product?.pay_later_status
        ? product?.commission_price
        : product?.price,
      price_before_discount: product?.price_before_discount,
      ...form,
      departure_flight_no: form.departure_flight_no?.trim() || "TBC",
      arrival_flight_no: form.arrival_flight_no?.trim() || "TBC",
      discount_amount: product.discount || "0.00",
      discount_code: getPromocode?.toString() || "",
      admin_charges: product.admin_charges,
      cancellation_status: cancellation ? "1" : "0",
      sms_confirmation: sms ? "1" : "0",
      icampaign: cookie,
      // UTM data from unified tracking library
      utm_source: loadTrackingData()?.utm_source || Cookies.get("utm_source") || "organic",
      utm_medium: loadTrackingData()?.utm_medium || Cookies.get("utm_medium") || "organic",
      utm_campaign: loadTrackingData()?.utm_campaign || Cookies.get("utm_campaign") || "",
      utm_term: loadTrackingData()?.utm_term || Cookies.get("utm_term") || "",
      utm_content: loadTrackingData()?.utm_content || "",
      session_id: loadTrackingData()?.session_id || "",
    };

    try {
      if (multi_mode_reference_no.length === 0 && reference_no.length === 0) {
        //@ts-ignore

        const storeResponse = await apiCall(
          "post",
          "/bookings/store",
          details,
          {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          pathname
        );
        if (
          storeResponse.data?.reference_no &&
          storeResponse.data?.multi_mode_reference_no
        ) {
          // if (typeof sessionStorage !== "undefined") {
          //   sessionStorage.setItem(
          //     "detail",
          //     JSON.stringify({
          //       ...details,
          //       reference_no: storeResponse.data?.reference_no,
          //       multi_mode_reference_no:
          //         storeResponse.data?.multi_mode_reference_no,
          //     })
          //   );
          // }
          //Stripe
          if (site?.stripe) {
            await apiCall(
              "post",
              "/stripe/paymentIntent/update",
              {
                key: apiKey,
                payment_intent: stripePaymentIntent,
                multi_mode_reference_no:
                  storeResponse.data?.multi_mode_reference_no,
                reference_no: storeResponse.data?.reference_no,
                amount: total,
                api_tag: product?.api_tag,
              },
              {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              pathname
            );
          }
          setMulti_mode_reference_no(
            storeResponse.data?.multi_mode_reference_no
          );
          //@ts-ignore
          setReference_no(storeResponse.data?.reference_no);
          inComingIncompleteBooking({
            data: {
              reference_no: Array.isArray(storeResponse.data?.reference_no)
                ? storeResponse.data?.reference_no[0]
                : storeResponse.data?.reference_no,
              db_source: "apd",
            },
            token: apiKey,
          });

          updateTrackingReferenceFromBooking(storeResponse);

          return storeResponse?.data;
        }
      } else {
        let updateResponse;
        //@ts-ignore
        if (product?.customer) {
          updateResponse = await apiCall(
            "post",
            "/bookings/update",
            {
              key: apiKey,
              multi_mode_reference_no,
              status: "0",
              departure: `${moment(product?.departure_date).format(
                "DD-MM-yyyy"
              )} ${product?.departure_time.slice(0, -3)}`,
              arrival: `${moment(product?.arrival_date).format(
                "DD-MM-yyyy"
              )} ${product?.arrival_time.slice(0, -3)}`,
              sku: product?.sku,
              title: product?.customer?.title,
              first_name: product?.customer?.first_name,
              last_name: product?.customer?.last_name,
              email: product?.customer?.email,
              contact_no: product?.customer?.contact_no,
              no_of_peoples: product?.customer?.no_of_peoples,
              address: "",
              postcode: "",
              //@ts-ignore
              vehicles,
              departure_terminal: product?.departure_terminal,
              departure_flight_no: product?.departure_flight_no || "TBC",
              arrival_terminal: product?.arrival_terminal,
              arrival_flight_no: product?.arrival_flight_no || "TBC",
              amount: product?.payment?.amount,
              discount_amount: product?.payment?.discount || "0.00",
              discount_code: product?.payment?.discount_code?.toString() || "",
              admin_charges: product?.payment?.admin_charges,
              cancellation_status: `${product?.cancellation_status}`,
              sms_confirmation: `${product?.sms_confirmation}`,
              option_id: product?.option_id
                ? JSON.stringify(product?.option_id)
                : "",
              search_id: product?.search_id ? product?.search_id : "",
              api_tag: product?.api_tag,
            },
            {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
            pathname
          );
        } else {
          updateResponse = await apiCall(
            "post",
            "/bookings/update",
            {
              key: apiKey,
              multi_mode_reference_no,
              status: "0",
              departure: moment(getDeparture).format("DD-MM-yyyy HH:mm"),
              arrival: moment(getArrival).format("DD-MM-yyyy HH:mm"),
              sku: product?.sku,
              ...form,
              departure_flight_no: form.departure_flight_no?.trim() || "TBC",
              arrival_flight_no: form.arrival_flight_no?.trim() || "TBC",
              amount: product?.pay_later_status
                ? product?.commission_price
                : product?.price,

              price_before_discount: product?.price_before_discount,
              discount_amount: product.discount || "0.00",
              discount_code: getPromocode?.toString() || "",
              admin_charges: product?.admin_charges,
              cancellation_status: cancellation ? "1" : "0",
              sms_confirmation: sms ? "1" : "0",
              option_id: product?.option_id
                ? JSON.stringify(product?.option_id)
                : "",
              search_id: product?.search_id ? product?.search_id : "",
              api_tag: product?.api_tag,
              icampaign: cookie,
            },
            {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
            pathname
          );
        }
        if (
          updateResponse.data?.reference_no &&
          updateResponse.data?.multi_mode_reference_no
        ) {
          //Stripe
          if (typeof window !== "undefined") {
            sessionStorage.setItem(
              "detail",
              JSON.stringify({
                ...details,
                reference_no: updateResponse.data?.reference_no,
                multi_mode_reference_no:
                  updateResponse.data?.multi_mode_reference_no,
              })
            );
          }
          if (site?.stripe) {
            // await apiCall(
            //   "post",
            //   "/stripe/paymentIntent/update",
            //   {
            //     key: apiKey,
            //     payment_intent: stripePaymentIntent,
            //     multi_mode_reference_no:
            //       updateResponse.data?.multi_mode_reference_no,
            //     reference_no: updateResponse.data?.reference_no,
            //     amount: total,
            //     api_tag: product?.api_tag,
            //   },
            //   {
            //     "Content-Type": "application/json",
            //     "Access-Control-Allow-Origin": "*",
            //   },
            //   pathname
            // );
            let updateIntentData = await apiCall(
              "post",
              "/stripe/paymentIntent/update",
              {
                key: apiKey,
                payment_intent: stripePaymentIntent,
                multi_mode_reference_no:
                  updateResponse.data?.multi_mode_reference_no,
                reference_no: updateResponse.data?.reference_no,
                amount: total,
                api_tag: product?.api_tag,
              },
              {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              pathname
            );

            if (updateIntentData?.data?.client_secret) {
              apiCall(
                "post",
                "/bookings/updateIntent",
                {
                  key: apiKey,
                  payment_token: updateIntentData?.data?.payment_intent,
                  multi_mode_reference_no:
                    updateResponse.data?.multi_mode_reference_no,
                },
                {
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                },
                pathname
              );
            }
          }

          setMulti_mode_reference_no(
            updateResponse.data?.multi_mode_reference_no
          );
          setReference_no(updateResponse.data?.reference_no);
          inComingIncompleteBooking({
            data: {
              reference_no: Array.isArray(updateResponse.data?.reference_no)
                ? updateResponse.data?.reference_no[0]
                : updateResponse.data?.reference_no,
              db_source: "apd",
            },
            token: apiKey,
          });

          updateTrackingReferenceFromBooking(updateResponse);

          return updateResponse?.data;
        } else {
          setResponseError(updateResponse.message);
          return;
        }
        // }
      }
      setState("success");
    } catch (error) {
      setState("error");
      setStatus(error.message);
    }
  };

  const handleValidate = () => {
    let errorResponse = validateBookingForm(
      product?.customer
        ? {
          title: product?.customer?.title,
          first_name: product?.customer?.first_name,
          last_name: product?.customer?.last_name,
          email: product?.customer?.email,
          contact_no: product?.customer?.contact_no,
        }
        : form,
      vehicles,
      agree
    );
    setErrors(errorResponse.errors);
    // setValidationErrorState(errorResponse?.state);

    if (errorResponse?.errors.length > 0 && errorResponse?.state === "error") {
      errorResponse?.errors.map((error) => {
        toast.error(error?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
      return false;
    } else {
      return true;
    }
  };

  const handleAddVehicle = (e) => {
    e.preventDefault();
    setVehicles((vehicles) => [
      ...vehicles,
      {
        model: "TBC",
        color: "TBC",
        make: "TBC",
        reg_no: "TBC",
      },
    ]);
  };

  const handleRemoveVehicle = (e, index) => {
    e.preventDefault();
    let vehicleArray = [...vehicles];

    vehicleArray.splice(index, 1);
    setVehicles(vehicleArray);
  };

  // @ts-ignore
  const handleChange = (e, index) => {
    let vehicleArray = [...vehicles];
    let vehicleObj = vehicleArray[index];
    // @ts-ignore
    vehicleObj[e.target.name] = e.target.value;
    setVehicles(vehicleArray);
  };

  return (
    <>
      <div className="booking-form-container flex-[2_1_0%] lg:mr-[30px] mr-0">
        {status ? (
          <div className="bg-red-50 text-red-600 border border-red-200 p-5 rounded-2xl text-center font-bold mb-6 shadow-sm">
            <strong>{status?.toUpperCase()}</strong>
          </div>
        ) : null}
        {pathname != "/payment" && (
          <div className="shadow-box">
            <UserDetails
              form={form}
              errors={errors}
              setFormField={setFormField}
              type={product?.type}
            />
            <TravelDetails
              form={form}
              setFormField={setFormField}
              index={findIndex}
              updateAirports={updateAirports}
            />
          </div>
        )}
        {pathname != "/payment" &&
          vehicles?.map((vehicle, index) => {
            return (
              <>
                <VehicleDetails
                  key={index}
                  id={index}
                  index={index}
                  product={product}
                  vehicles={vehicles}
                  setVehicles={setVehicles}
                  handleChange={(e) => handleChange(e, index)}
                  errors={errors}
                  handleAddVehicle={handleAddVehicle}
                  handleRemoveVehicle={handleRemoveVehicle}
                />
              </>
            );
          })}
        {pathname != "/payment" && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-6 mx-auto w-full">
            {/* SMS Confirmation */}
            <div
              onClick={() => setSMS(!sms)}
              className={`relative flex items-center justify-between p-5 rounded-2xl cursor-pointer border transition-all duration-300 shadow-sm overflow-hidden select-none ${sms
                  ? "bg-gradient-to-br from-primary from-[80%] to-secondary text-white border-transparent shadow-lg scale-[1.01]"
                  : "bg-slate-100 text-slate-800 border-slate-200 hover:bg-slate-200/50"
                }`}
            >
              <div className="w-[80%]">
                <p className={`font-semibold text-base ${sms ? 'text-white' : 'text-slate-900'}`}>Text Message Confirmation</p>
                <p className={`text-sm font-medium mt-1 ${sms ? 'text-white/80' : 'text-slate-500'}`}>
                  (UK mobiles only) £ {product?.sms_charges || "0.90"}
                </p>
              </div>
              <div
                className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-all duration-300 border-2 ${sms
                    ? "bg-secondary text-primary border-secondary"
                    : "border-slate-400 text-transparent"
                  }`}
              >
                <FaCheck size={12} className="stroke-[3]" />
              </div>
            </div>

            {/* Cancellation Cover */}
            <div
              onClick={() => setCancellation(!cancellation)}
              className={`relative flex items-center justify-between p-5 rounded-2xl cursor-pointer border transition-all duration-300 shadow-sm overflow-hidden select-none ${cancellation
                  ? "bg-gradient-to-br from-primary from-[80%] to-secondary text-white border-transparent shadow-lg scale-[1.01]"
                  : "bg-slate-100 text-slate-800 border-slate-200 hover:bg-slate-200/50"
                }`}
            >
              <div className="w-[80%]">
                <p className={`font-semibold text-base ${cancellation ? 'text-white' : 'text-slate-900'}`}>Cancellation Cover</p>
                <p className={`text-sm font-medium mt-1 leading-snug ${cancellation ? 'text-white/80' : 'text-slate-500'}`}>
                  Protect your booking if you need to cancel or amend in future £ {product?.cancellation_charges || "0.90"}
                </p>
              </div>
              <div
                className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-all duration-300 border-2 ${cancellation
                    ? "bg-secondary text-primary border-secondary"
                    : "border-slate-400 text-transparent"
                  }`}
              >
                <FaCheck size={12} className="stroke-[3]" />
              </div>
            </div>
          </div>
        )}

        {clientSecret ? (
          <StripePay
            multiModeReference={multi_mode_reference_no}
            reference_no={reference_no}
            handleSyncBooking={handleSyncBooking}
            total={total}
            clientSecret={clientSecret}
            stripePaymentIntent={stripePaymentIntent}
            stripePromise={stripePromise}
            firstName={form?.first_name}
            lastName={form?.last_name}
            email={form?.email}
            mobile={form?.contact_no}
            airport={
              singleAirport
                ? singleAirport?.label
                : updateAirports[findIndex].label
            }
            discountCode={getPromocode}
            handleValidate={handleValidate}
            responseError={responseError}
            service={product?.type}
            supplierCost={parseFloat(supplierCost) * 0.25}
            api_tag={product?.api_tag}
            isVehicle={isVehicle}
            product={product}
            setAgree={setAgree}
            agree={agree}
            error={error}
          />
        ) : null}
      </div>
    </>
  );
};

export default BookingForm;
